import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { AmericanCountryList, ChubbCountryList, EuropeanUnionHiscoxList, EuropeanUnionList } from '../constants/quote';
export var useConstantDataStore = create()(immer(function (set, get) {
  return {
    state: {
      europeanUnionHiscoxList: EuropeanUnionHiscoxList,
      europeanUnionList: EuropeanUnionList,
      chubbCountryList: ChubbCountryList,
      americanList: AmericanCountryList
    },
    actions: {}
  };
}));